<template>
  <div
    :class="[
      'keyd-map',
      `keyd-map--items-${keydsmap.length}`,
      { 'keyd-map--no-panel': keyd_map_depth <= 3 },
    ]"
    ref="keyd-map"
  >
    <loader v-if="loading" />
    <div v-else>
      <b-row v-if="keydsmap.length == 0">
        <b-col sm="12">
          <p class="text-center my-4 mb-0">
            <i>
              Non abbiamo trovato disponibilità per questo numero di
              viaggiatori, prova a cambiare il numero di viaggiatori
            </i>
          </p>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col
          cols="6"
          class="keyd-map__column"
          v-for="item in keydsmap"
          v-bind:key="item.l"
          :ref="get_toggle_id(item.l)"
        >
          <h5 class="keyd-map__title">
            <vb-icon class="mr-2" :name="'pin'" :size="18" />
            {{ item.l | capitalize }}
          </h5>
          <div
            v-for="sub in item.d"
            v-bind:key="sub.l"
            class="pb-1 keyd-map__holder"
            :ref="get_toggle_id(sub.l)"
          >
            <div
              class="d-inline-flex align-items-center keyd-map__label"
              @click.stop="
                if (sub.d) return;
                get_location(sub);
              "
              v-b-toggle="get_toggle_id(sub.l)"
            >
              <div class="mr-2">
                {{ sub.l | capitalize }}
                <!--<span v-if="sub.pf" class="text text--sm text-primary ml-1">da {{sub.pf}} €</span>-->
              </div>
            </div>
            <b-collapse v-if="sub.d" class="ml-2" :id="get_toggle_id(sub.l)">
              <div
                class="d-flex align-items-center keyd-map__label"
                @click.stop="get_location(sub)"
              >
                {{ sub.l | capitalize }}
              </div>
              <div
                v-for="sub_d in sub.d"
                :key="sub_d.l"
                :ref="`label-${get_toggle_id(sub_d.l)}`"
                class="ml-2 d-flex align-items-center keyd-map__label"
                @click.stop="
                  if (sub_d.d) {
                    get_content(sub, sub_d);
                    set_position(
                      get_toggle_id(sub.l),
                      get_toggle_id(item.l),
                      get_toggle_id(sub_d.l),
                    );
                    return;
                  }
                  get_location(sub_d);
                "
              >
                <div class="mr-2">{{ sub_d.l | capitalize }}</div>
              </div>
            </b-collapse>
          </div>
        </b-col>
        <b-col v-if="keyd_map_depth > 3" cols="6" class="keyd-map__column">
          <!--<div class="keyd-map__panel" :style="'top:'+pos_y+';left:'+pos_x+';'">-->
          <div class="keyd-map__panel" :class="{ show: show_panel }">
            <vb-icon
              class="ml-3 mt-2 cursor-pointer"
              :name="'arrow_l'"
              :size="20"
              @click.stop="close_panel()"
            />
            <ul class="keyd-map__panel--first">
              <keyd-node
                :node="panel_content"
                :parent="panel_parents"
                @keyd="(event) => get_location(event)"
              />
            </ul>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import keydNode from "./keyd-node";
import { mapState } from "vuex";
import { encode_parameters } from "@utilities";
import { endpoints_keys } from "@alpitour/resources/package_types";
import { build_keydmap_request } from "@alpitour/components/blocks/booking-engine/logic";
import { keydmap_max_depth } from "@alpitour/utilities/keyd-map";
import { has_valid_occupancy } from "@alpitour/utilities";
import { alpitour_service_handler } from "@alpitour/services/common";

export default {
  name: "keyd-map",
  components: {
    "keyd-node": keydNode,
  },
  computed: {
    // module state keys
    ...mapState("liveat", ["keydsmap", "package_type"]),
    // global state keys
    ...mapState(["occupancy"]),
    keyd_map_depth() {
      return keydmap_max_depth(this.keydsmap);
    },
  },
  created() {
    this.encode_parameters = encode_parameters;
  },
  data() {
    return {
      panel_content: {},
      panel_parents: {},
      pos_y: 0,
      pos_x: 0,
      show_panel: false,
      loading: false,
      keyd_map_request_id: 0,
    };
  },
  mounted() {
    if (!has_valid_occupancy(this.occupancy)) {
      return;
    }
    this.get_keyd_map();
  },
  methods: {
    get_keyd_map() {
      const request_id = ++this.keyd_map_request_id;
      this.loading = true;
      this.$store.commit("liveat/keydsmap", []);
      const request = build_keydmap_request(this.package_type, {
        brands: this.get_config("guiSettings.filterBrands", []),
        occupancy: this.occupancy[0],
      });
      alpitour_service_handler(endpoints_keys.keydsMap, request, {
        modal: false,
      })
        .then(
          (success) => {
            if (request_id !== this.keyd_map_request_id) return;
            this.$store.commit("liveat/keydsmap", success.data.keydsMap);
          },
          (error) => {
            this.log("[keyd-map.vue] - error");
            this.log(error);
            this.$store.commit("liveat/keydsmap", []);
          },
        )
        .finally(() => {
          if (request_id === this.keyd_map_request_id) {
            this.loading = false;
          }
        });
    },
    get_toggle_id(str) {
      return str.replaceAll(" ", "");
    },
    get_content(item, item_d) {
      let active = document.querySelectorAll(".keyd-map__label.active");
      if (active.length) active[0].classList.remove("active");
      this.panel_content = item_d;
      this.panel_parents = item;
      this.show_panel = true;
    },
    get_location(item) {
      this.$emit("keyd", item.k);
    },
    set_position(ref_top, ref_left, child) {
      const item = this.$refs[`label-${child}`][0];
      const item_top = this.$refs[ref_top][0];
      const item_left = this.$refs[ref_left][0].offsetLeft;
      const active = document.querySelectorAll(".keyd-map__label.active");

      if (item.classList.contains("active")) {
        return;
      }
      if (active.length) {
        active[0].classList.remove("active");
      }

      this.pos_y = `${item_top.offsetTop + item_top.offsetHeight / 2}px`;
      this.pos_x = `${item_left + item.offsetWidth + 20}px`;
      item.classList.add("active");
    },
    close_panel() {
      this.show_panel = false;
      const active = document.querySelectorAll(".keyd-map__label.active");
      if (active.length) {
        active[0].classList.remove("active");
      }
    },
  },
  watch: {
    package_type: {
      //! This can surely be optimized later
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.get_keyd_map();
        }
      },
    },
  },
};
</script>

<style lang="scss">
.keyd-map {
  overflow: hidden;
  position: relative;

  // 5 content cols + panel: 5×16% + 20% = 100%
  &--items-5:not(.keyd-map--no-panel) {
    .keyd-map__column {
      @include media-breakpoint-up(md) {
        position: relative !important;
        flex: 20% !important;
        max-width: 16% !important;
      }
    }
    .keyd-map__column:last-child {
      max-width: 20% !important;
    }
  }

  // No panel: content columns fill the full row
  &--no-panel {
    // 4 content cols: 4×25% = 100%
    .keyd-map__column {
      @include media-breakpoint-up(md) {
        flex: 25% !important;
        max-width: 25% !important;
      }
    }
    // 5 content cols: 5×20% = 100%
    &.keyd-map--items-5 .keyd-map__column {
      @include media-breakpoint-up(md) {
        flex: 20% !important;
        max-width: 20% !important;
      }
    }
  }

  &__column {
    position: static !important;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    // Default: 4 content cols + panel = 5 cols × 20% = 100%
    @include media-breakpoint-up(md) {
      position: relative !important;
      flex: 20% !important;
      max-width: 20% !important;
    }
  }
  &__title {
    display: flex;
    align-items: center;
    color: $gray-500;
    svg path {
      fill: $gray-500;
    }
    border-bottom: 1px solid $gray-200;
    min-width: 100%;
    padding-bottom: 0.35rem;
    margin-bottom: 0.35rem;
  }
  &__holder {
    position: relative;
    display: inline-block;
    .not-collapsed {
      color: $primary;
    }
  }
  &__panel {
    position: absolute;
    top: 0;
    right: 0;
    //transform:translateY(-30%);
    //max-width: 300px;
    transition: $transition-base;
    background: $white; // $gray-200;
    border-radius: $border-radius;
    transform: translateX(100%);
    opacity: 0;
    width: 75%;
    padding-bottom: 16px;
    &.show {
      transform: none;
      opacity: 1;
      background: $vb-body-bg;
      * {
        background: transparent;
      }
    }
    &--first {
      margin: 0;
      padding: 0;
      height: calc(100% - 28px);
      & > .keyd-map__node {
        width: 100%;
        height: 100%;
        max-height: 360px;
        overflow: scroll;
      }
    }
    @include media-breakpoint-up(md) {
      width: calc(100% - #{$grid-gutter-width});
      right: $grid-gutter-width/2;
      bottom: 0;
      &--first {
        & > .keyd-map__node {
          height: 100%;
          max-height: 100%;
        }
      }
    }
  }
  &__label {
    &.active {
      color: $primary;
    }
    cursor: pointer;
    transition: $transition-base;
    &:hover {
      color: $primary;
    }
  }
}
</style>
